import { render, staticRenderFns } from "./SponsoredRecommendationVideoNewPage.vue?vue&type=template&id=7492d8d1&scoped=true"
import script from "./SponsoredRecommendationVideoNewPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsoredRecommendationVideoNewPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SponsoredRecommendationVideoNewPage.vue?vue&type=style&index=0&id=7492d8d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7492d8d1",
  null
  
)

export default component.exports